import { render, staticRenderFns } from "./centerWalletTop.vue?vue&type=template&id=5d53aa9d&scoped=true&"
import script from "./centerWalletTop.vue?vue&type=script&lang=js&"
export * from "./centerWalletTop.vue?vue&type=script&lang=js&"
import style0 from "./centerWalletTop.vue?vue&type=style&index=0&id=5d53aa9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53aa9d",
  null
  
)

export default component.exports